import React, {useEffect, useState} from 'react';
import { notification } from '../../hocs/notification';

import axios from 'axios';
import { mainurl } from '../../../Mainurl';

import {FaHeading} from 'react-icons/fa';
import { Row, Col, Card, CardBody, CardHeader, Form, FormGroup, Input, Label, InputGroup, InputGroupText, Spinner, Button } from 'reactstrap';

    const AddEventTopic = ({back}) => {
    const [loading, setLoading] = useState(false);
    const [topic, setTopic] = useState('');
   

    const add_handler = (e) => {
        e.preventDefault();

       
        let postData = [{
            "org_id": sessionStorage.getItem('org_id'), 
            "topic_desc": topic,
            
        }];

        console.log(postData);
        axios({
            method: 'post',
            url: mainurl + 'Common/event_topic_add',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
        .then(function (response) {
            if(response.data[0].retcode == 101){
                let notify = notification({ message: "Event added Successfully.", type: 'info', time:true, position:'center' });
                notify();
                back();
            }
        })
        .catch(error => {
            let notify = notification({ message: "Submit failed! Try Again", type: 'error',  time:true });
            notify();
        });
    }
   
    return (
        <>
            <Card className='mb-3' color="primary" outline>
                <CardHeader> Add New Event Topic </CardHeader>
                <CardBody>
                    <Form onSubmit={add_handler}>

                        <FormGroup row>
                            <Label for="name" sm={2} > Topic Descripation </Label>
                            <Col sm={4}>
                                <Input id="name" type='text' bsSize="sm" value={topic} onChange={(e) => setTopic(e.target.value)} required />
                            </Col>
                        </FormGroup>
                       
                      <Row>
                            <hr />
                            <Col md={2} className="mb-2">
                                <Button className='text-white' color='primary' size="sm" block> Submit </Button>
                            </Col>
                        </Row>
                    </Form>
                </CardBody>
            </Card>
            <div className='text-end'>
                <Button className='text-white' color='primary' size="sm" onClick={back}> Back </Button>
            </div>
        </>
    )
}

export default AddEventTopic;